<template>
	<v-tooltip top>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				fab
				small
				color="white"
				v-bind="attrs"
				@click.prevent="onClick"
				v-on="on"
			>
				<v-icon
					color="#BDBDBD"
					dark
				>
					delete
				</v-icon>
			</v-btn>
		</template>
		<span>מחיקה</span>
	</v-tooltip>
</template>

<script>
export default {
	name: "RemoveBtn",
	components: {},
	props: {
		data: { required: false, default: null },
		options: {
			type: Object,
			default: () => {
				return {};
			},
		},
    title:{required: false, default:undefined}
	},
	data () {
		return {};
	},
	computed: {},
	methods: {
		onClick () {
			this.$emit("click", this.data);
			this.$notfication.warning(this.title, undefined, this.options).then((event) => {
				if (event.value) {
					this.$emit("remove", event.value);
				}
			});
		},
	},
};
</script>

		<style scoped>
			button {
			/*float: left;*/
			}

			.red-color {
			color: #cccccc !important;
			}
		</style>
	</v-tooltip>
</template>
